// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import msessEntity from './entities/msess.json';
import msessMenu from '../pages/msess/menu.json';
import msessFullForm from '../pages/msess/forms/full.json';
import msessContextForm from '../pages/msess/forms/context.json';
import msessMiniForm from '../pages/msess/forms/mini.json';
import msessLookupForm from '../pages/msess/forms/lookup.json';
import msessTableView from '../pages/msess/views/table.json';
import msessStagesView from '../pages/msess/views/stages.json';
import msessCardsView from '../pages/msess/views/cards.json';
import msessInlineView from '../pages/msess/views/inline.json';
import msessBacklogView from '../pages/msess/views/backlog.json';
import msessSplitView from '../pages/msess/views/split.json';
import msessCalendarView from '../pages/msess/views/calendar.json';
import msessDashboardView from '../pages/msess/views/dashboard.json';

/** Тип запису «Менторська сесія» зі сторінками пакета: меню, форми та подання з pages/msess/. */
export const msessDefinition: IRecordTypeDefinition = {
  ...msessEntity,
  views: assembleViewSet({
      table: msessTableView,
      stages: msessStagesView,
      cards: msessCardsView,
      inline: msessInlineView,
      backlog: msessBacklogView,
      split: msessSplitView,
      calendar: msessCalendarView,
      dashboard: msessDashboardView,
  }),
  form: msessFullForm,
  forms: { full: msessFullForm, context: msessContextForm, mini: msessMiniForm, lookup: msessLookupForm },
  menu: msessMenu,
} as IRecordTypeDefinition;
